module.exports = __webpack_public_path__ + "media/images/wines/syrah-24-barricas/bottle-detail-e6e192d27253d2845b9384e89fbacba0.png";